import { BackgroundColor } from '@/gql/graphql';

export const backgroundMapper: Record<
  BackgroundColor,
  { light: string; base: string }
> = {
  Info: { light: '#b3d9eb', base: '#0984bd' },
  Warnung: { light: '#fed8b3', base: '#fd820b' },
  Fatal: { light: '#f8c1c2', base: '#ea383a' },
};
